import React, { createContext, useContext } from 'react'

import {
  getPartnersByLocation,
  getPartnersByStoreName
} from '../services/partnerService'

import MODAL from '../utils/modals'
import { DEFAULT_ERROR } from '../utils/schedulingConstants'

import { useServiceScheduleContext, actionTypes } from './serviceScheduleContext'

export const locationContext = createContext()

// contexto de estado
export function LocationContextProvider ({ children }) {
  const { state, dispatch, state: schedulingState, functions: schedulingFunctions } = useServiceScheduleContext()

  const {
    handleSetRescheduleDataLoaded,
    handleWarningModalClose,

    findPartnerScheduleAndCampaignAviability
  } = schedulingFunctions

  // busca de lojas
  const retrievePartnersData = async (scheduleBody, props, coordinates = '') => {
    const { context } = props

    const {
      error,
      cep,
      address,
      storeName,
      schedulingData,
      formList,
      rescheduleDataLoaded
    } = state

    const usingGeolocation = !!coordinates

    const { locations, service_id: serviceId } = scheduleBody

    const additionalServices = scheduleBody.additional_services || []

    if (serviceId && (usingGeolocation || locations || cep || storeName || scheduleBody?.storeName)) {
      context.showLoader()

      let partnersList = []

      if (!usingGeolocation && (storeName || scheduleBody?.storeName)) {
        partnersList = await getPartnersByStoreName(storeName || scheduleBody?.storeName)
      } else {
        const newLocation = !usingGeolocation
          ? locations && address
            ? `${locations}`
            : cep
          : coordinates

        partnersList = await getPartnersByLocation(
          newLocation,
          serviceId,
          0,
          4,
          additionalServices
        )
      }

      const partners = !usingGeolocation && (storeName || scheduleBody?.storeName) ? partnersList : partnersList.partners

      if (partners?.length > 0) {
        dispatch({
          type: actionTypes.UPDATE_STATE,
          payload: {
            partnersData: partners,
            totalPartners: partnersList.total
          }
        })

        // Se é um reagendamento, seleciona a loja escolhida no agendamento anterior
        if (
          !rescheduleDataLoaded &&
          schedulingData &&
          schedulingData.partner?.id &&
          scheduleBody.partner_id === undefined &&
          formList.length === 0
        ) {
          await handleSelectPartner(schedulingData.partner.id, props)
        }
      } else {
        dispatch({
          type: actionTypes.UPDATE_STATE,
          payload: {
            scheduleBody: {
              ...scheduleBody,
              partner_id: undefined,
              professional_id: '',
              selectDay: undefined,
              selectTime: undefined
            }
          }
        })

        dispatch({
          type: actionTypes.UPDATE_STATE,
          payload: {
            modal: MODAL.PARTNER_NOT_FOUND(storeName, handleWarningModalClose()),
            partnersData: [],
            pricesData: [],
            error: {
              ...error,
              partner_id: DEFAULT_ERROR.partner_id,
              selectDay: DEFAULT_ERROR.selectDay,
              selectTime: DEFAULT_ERROR.selectTime
            }
          }
        })

        handleSetRescheduleDataLoaded()
      }
    }

    context.hideLoader()
  }

  const loadMorePartnersData = async (props) => {
    try {
      const { context } = props
      const {
        cep,
        address,
        scheduleBody,
        usingGeolocation,
        partnersData
      } = state
      const { locations, service_id: serviceId } = scheduleBody

      const additionalServices = scheduleBody.additional_services || []

      if (serviceId && (usingGeolocation || locations || cep)) {
        context.showLoader()
        let partnersList = []

        const newLocation = !usingGeolocation
          ? locations && address
            ? `${locations}`
            : cep
          : locations

        partnersList = await getPartnersByLocation(
          newLocation,
          serviceId,
          partnersData.length || 0,
          4,
          additionalServices
        )

        const partners = partnersList.partners

        if (partners?.length > 0) {
          dispatch({
            type: actionTypes.UPDATE_STATE,
            payload: {
              partnersData: [...partnersData, ...partners],
              totalPartners: partnersList.total
            }
          })
        }
      }
      context.hideLoader()
    } catch (err) {
      console.error(err)
    }
  }

  // lida com inputs
  const handleLocationInputData = (props) => {
    const { context } = props
    const { scheduleBody } = state

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        usingGeolocation: false,
        scheduleBody: {
          ...scheduleBody,
          partner_id: undefined,
          professional_id: ''
        },
        noPreference: false
      }
    })

    retrievePartnersData(scheduleBody, { context })
  }

  const handleDeviceLocation = (props) => {
    const { context } = props

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coordinates = position.coords.latitude
            .toString()
            .concat(',')
            .concat(position.coords.longitude.toString())

          dispatch({
            type: actionTypes.UPDATE_STATE,
            payload: {
              scheduleBody: {
                ...state.scheduleBody,
                locations: coordinates,
                partner_id: undefined
              },
              usingGeolocation: true
            }
          })

          retrievePartnersData(state.scheduleBody, { context }, coordinates)
        },
        (positionError) => {
          dispatch({
            type: actionTypes.UPDATE_STATE,
            payload: {
              modal: MODAL.LOCATION_NOT_ALLOWED()
            }
          })

          handleSetRescheduleDataLoaded()
        }
      )
    } else {
      dispatch({
        type: actionTypes.UPDATE_STATE,
        payload: {
          modal: MODAL.LOCATION_NOT_ALLOWED()
        }
      })

      handleSetRescheduleDataLoaded()
    }
  }

  const handleOpenCustomAddress = (value, props, index = 0) => {
    const { context } = props
    const { userAddresses } = context
    const { customAddressType } = schedulingState
    const street = userAddresses?.[index]?.street
    const streetNumber = userAddresses?.[index]?.streetNumber
    const city = userAddresses?.[index]?.city
    const coordinates = userAddresses?.[index]?.geoCoordinate?.length && `${userAddresses[index].geoCoordinate[1]},${userAddresses[index].geoCoordinate[0]}`

    if (customAddressType !== value || customAddressType === 'address') {
      dispatch({
        type: actionTypes.UPDATE_STATE,
        payload: {
          isCustomAddress: ['address', 'cep', 'storeName'].includes(value),
          customAddressType: value,
          cep: undefined,
          ...((userAddresses?.length > 0 && value === 'address') ? { address: `${street} ${streetNumber}, ${city}` } : { address: undefined }),
          storeName: undefined,
          locations: undefined,
          partnersData: [],
          scheduleBody: {
            ...state.scheduleBody,
            partner_id: undefined,
            ...((userAddresses?.length > 0 && value === 'address') ? { locations: coordinates } : { locations: undefined })
          }
        }
      })
    }

    if (value === 'location') handleDeviceLocation({ context })
  }

  const handleEditCep = (event) => {
    const { name, value } = event.target
    const { error } = state
    const newError = Object.assign({}, error)
    newError[name] =
      value !== undefined && value !== null && value !== ''
        ? undefined
        : 'Insira um valor válido'

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        cep: value,
        address: undefined,
        storeName: undefined,
        error: newError
      }
    })
  }

  const handleEditLocation = (event) => {
    event.preventDefault()
    const { name, value } = event.target
    const { scheduleBody, error } = state
    const newError = Object.assign({}, error)
    newError[name] =
      value !== undefined && value !== null && value !== ''
        ? undefined
        : 'Insira um valor válido'

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        address: value,
        scheduleBody: {
          ...scheduleBody,
          locations: value
        },
        error: newError
      }
    })
  }

  const handleEditStoreName = (event) => {
    event.preventDefault()
    const { name, value } = event.target
    const { error } = state
    const newError = Object.assign({}, error)
    newError[name] =
      value !== undefined && value !== null && value !== ''
        ? undefined
        : 'Insira um valor válido'

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        cep: undefined,
        address: undefined,
        error: newError,
        storeName: value
      }
    })
  }

  const handleSetChangeStore = (status) => {
    const { scheduleBody } = state

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        scheduleBody: {
          ...scheduleBody,
          partner_id: undefined
        },
        changeStore: status,
        selectedPetSchedule: undefined
      }
    })
  }

  // seleciona outro dia e horario em multiplos agendamentos
  const handleSelectAnotherDayAndHour = () => {
    const { scheduleBody, formList, error } = state

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        activeCampaign: undefined,
        productCoupon: undefined,
        pricesData: formList[0].data.pricesData,
        invertStep: undefined,
        scheduleBody: {
          ...scheduleBody,
          partner_id: undefined,
          samePetDate: false
        },
        error: {
          ...error,
          unavailabilityPets: []
        },
        partnersData: formList[0].data.partnersData?.filter(({ id }) => id === formList[0].data.scheduleBody.partner_id),
        customAddressType: formList[0].data.customAddressType,
        isCustomAddress: formList[0].data.isCustomAddress,
        usingGeolocation: formList[0].data.usingGeolocation,
        storeName: formList[0].data.usingGeolocation,
        availableDates: formList[0].data.availableDates,
        availableSlots: formList[0].data.availableSlots,
        changeStore: false
      }
    })
  }

  // seleciona loja
  const handleSelectPartner = async (partnerId, props, selectedForm) => {
    const { context } = props

    context.showLoader()

    const { scheduleBody: { selectDay = undefined }, schedulingCoupon } = state

    const newState = await findPartnerScheduleAndCampaignAviability(partnerId, selectDay, selectedForm)

    if ((newState?.customAddressType === 'location' || newState?.customAddressType === 'address') && newState?.formList?.length > 0) {
      const filteredPartner = newState?.partnersData?.filter(({ id }) => id === newState?.scheduleBody?.partner_id)
      newState.partnersData = filteredPartner
    }

    const isAppliedCouponValid = () => { return schedulingCoupon?.partners.includes(newState?.scheduleBody?.partner_id) }

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        ...newState,
        scheduleBody: {
          ...newState.scheduleBody,
          samePetDate: !!selectedForm,
          schedulingCoupon: isAppliedCouponValid() ? schedulingCoupon : undefined
        }
      }
    })

    context.hideLoader()
  }

  // exporta as funções
  const functions = {
    retrievePartnersData,
    loadMorePartnersData,

    handleLocationInputData,
    handleDeviceLocation,
    handleOpenCustomAddress,
    handleEditCep,
    handleEditLocation,
    handleEditStoreName,
    handleSetChangeStore,

    handleSelectAnotherDayAndHour,

    handleSelectPartner
  }

  return (
    <locationContext.Provider value={{ functions }}>
      {children}
    </locationContext.Provider>
  )
}

// Hook para acessar o contexto
export function useLocationContext () {
  const context = useContext(locationContext)

  if (!context) {
    throw new Error('useLocationContext deve ser usado dentro de um Provider!')
  }

  const { functions } = context
  return { functions }
}
